import { render, staticRenderFns } from "./CandidateReleaseForm.vue?vue&type=template&id=091f39fa&scoped=true&"
import script from "./CandidateReleaseForm.vue?vue&type=script&lang=js&"
export * from "./CandidateReleaseForm.vue?vue&type=script&lang=js&"
import style0 from "./CandidateReleaseForm.vue?vue&type=style&index=0&id=091f39fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091f39fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
